import { Injectable } from "@angular/core";
import { CheckboxTreeviewComponent } from "../components/checkbox-treeview/checkbox-treeview.component";

@Injectable()
export class CheckboxTreeviewEventParser {
    getSelectedChange(component: CheckboxTreeviewComponent): any[] {
        return component.treeviewItems;
    }
}